<cbc-container [isLoading]="isLoading" 
[showContainer]="!isLoading" 
title="Gerenciar FAQ"
description="Gerencie as perguntas frequentes do sistema">
</cbc-container>

@if(!isLoading) {
<div class="container">
  <div class="card">
    <div class="card-header">
      <div class="card-title">FAQs Cadastradas</div>
      <button mat-fab extended color="primary" (click)="openFaqDialog()" class="btn btn-primary">
        <mat-icon>add</mat-icon>
        Nova FAQ
      </button>
    </div>
    
    <div class="card-body">
      @if(faqs.length === 0) {
      <div class="alert alert-info">
        <mat-icon>info</mat-icon>
        <div>
          <strong>Nenhuma FAQ cadastrada</strong>
          <p>Clique no botão "Nova FAQ" para adicionar a primeira pergunta frequente.</p>
        </div>
      </div>
      }

      @for (item of faqs; track item.id) {
      <div class="card card-white faq-item">
        <div style="display: flex; gap: var(--spacing-md); align-items: flex-start;">
          <div style="flex: 1;">
            <div class="info-row">
              <span class="info-label">Grupo:</span>
              <span class="info-separator"></span>
              <span class="badge badge-primary">{{ item.group }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">Pergunta:</span>
              <span class="info-separator"></span>
              <span class="info-data">{{ item.question }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">Resposta:</span>
              <span class="info-separator"></span>
              <span class="info-data">{{ item.response }}</span>
            </div>
            @if(item.link) {
            <div class="info-row">
              <span class="info-label">Link:</span>
              <span class="info-separator"></span>
              <span class="info-data">{{ item.link }}</span>
            </div>
            }
            @if(item.labellink) {
            <div class="info-row">
              <span class="info-label">Label:</span>
              <span class="info-separator"></span>
              <span class="info-data">{{ item.labellink }}</span>
            </div>
            }
          </div>
          <div style="display: flex; gap: var(--spacing-sm);">
            <button mat-icon-button (click)="editFaq(item)" matTooltip="Editar">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button color="warn" (click)="deleteFaq(item.id)" matTooltip="Excluir">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
</div>
}
